import { Feature, GeometryType } from "../../../core/geo/types";
import { Geometry, Position } from "geojson";
import { mapSegmentsToCoordinates } from "./mapSegment";

interface GeometryMapper {
    map: (feature: Feature) => Geometry;
}

const defaultMapper: GeometryMapper = {
    map(feature) {
        return { ...feature.geometry };
    },
};

const lineMapper: GeometryMapper = {
    map(feature) {
        const segments = feature.properties.segments;
        let coordinates: Position[] = mapSegmentsToCoordinates(segments);

        return {
            coordinates: coordinates,
            type: GeometryType.LINE_STRING,
        };
    },
};

const polygonMapper: GeometryMapper = {
    map(feature: Feature) {
        const segments = feature.properties.segments;
        let coordinates: Position[] = mapSegmentsToCoordinates(segments);
        return {
            coordinates: coordinates.length > 0 ? [coordinates] : [],
            type: GeometryType.POLYGON,
        };
    },
};

const geometryMappers: { [key in GeometryType]: GeometryMapper } = {
    Point: defaultMapper,
    LineString: lineMapper,
    Polygon: polygonMapper,
    GeometryCollection: defaultMapper,
    MultiLineString: defaultMapper,
    MultiPoint: defaultMapper,
    MultiPolygon: defaultMapper,
};

export const mapGeometry = (feature: Feature): Geometry => {
    return geometryMappers[feature.geometry.type].map(feature);
};
